import React, { useCallback } from "react";
import { FormAnswerField } from "../../../../../../interfaces/FormAnswerField";
import ItemRegister from "../../../../../ItemRegister";
import formAnswerToComboItemFromRegister from "../../../../../../utils/formAnswerToComboItemFromRegister";
import { Register } from "../../../../../../interfaces/Register";
import { useCardDialog } from "../../../../../../hooks/cardDialogContext";

interface ComboBoxFlowStepViewProps {
    values: FormAnswerField[];
    register: Register;
}

const ComboBoxRegisterView: React.FC<ComboBoxFlowStepViewProps> = ({ values, register }) => {

    const { openRegister } = useCardDialog();

    const handleOpenRegisterById = useCallback(async (form_answer_field_id: number) => {
        if (register !== undefined) {
            const findRegister = values.filter((item) => item.valueRegister !== undefined && item.valueRegister.id_form_answer === form_answer_field_id);
            if (findRegister.length > 0) {
                const registerToOpen = findRegister[0].valueRegister;
                if (registerToOpen !== undefined) {
                    openRegister(registerToOpen, register);
                }
            }
        }
    }, [openRegister, register, values]);

    return (
        <>
            {values !== undefined ?
                values.map((item) => (
                    item.valueRegister !== undefined && (
                        <ItemRegister
                            key={item.id_form_answer_field}
                            type={'Register'}
                            item={formAnswerToComboItemFromRegister(item.valueRegister, register)}
                            handleClick={register.typeUserAccess !== "V" ? handleOpenRegisterById : undefined}
                        />
                    )
                )) :
                <></>
            }
        </>
    );

}

export default ComboBoxRegisterView;